(function initYouTubeAPI() {
  // Reuse if already defined (so this is safe to include more than once)
  window.__ytReadyCallbacks = window.__ytReadyCallbacks || [];
  window.__ytApiLoaded = window.__ytApiLoaded || false;

  // Only inject the iframe API script once
  if (!document.querySelector('script[src^="https://www.youtube.com/iframe_api"]')) {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  }

  // Only define this if someone else hasn't already (defensive)
  if (!window.onYouTubeIframeAPIReady) {
    window.onYouTubeIframeAPIReady = function () {
      window.__ytApiLoaded = true;

      window.__ytReadyCallbacks.forEach(cb => {
        try { cb(); } catch (e) { console.error('YT ready callback error:', e); }
      });

      window.__ytReadyCallbacks = [];
    };
  }

  // Define the helper used by your other scripts
  if (!window.onYouTubeReady) {
    window.onYouTubeReady = function (callback) {
      if (window.__ytApiLoaded && window.YT && window.YT.Player) {
        callback();
      } else {
        window.__ytReadyCallbacks.push(callback);
      }
    };
  }
})();